import _ from 'lodash'
import unwrapModel from 'scoreboard/components/unwrap-model'

/**
 * Convenience functions for working with dataset paths
 */
const datasetPaths = {

	/**
	 * Returns the last dataset ID in a path
	 */
	lastDatasetId: function(path) {
		// something like ['252_2264', '251_2312'] where the first number in
		// each string is the datasetId, and the second one is the linked field
		// ID
		let datasetAndFieldIds = _.split(path, ',')
		let [datasetId] = _.split(_.last(datasetAndFieldIds), '_')
		return datasetId
	},

	/**
	 * Converts a path into an array of dataset and field objects in this
	 * format: [ { dataset, field, label, uniqueLink: true } ]
	 *
	 * @param {Dataset} dataset
	 * @param {String} path
	 *
	 * @typedef {Object} DatasetAndField
	 * @property {Dataset} dataset
	 * @property {Object} [field]
	 * @property {Boolean} uniqueLink
	 * @property {String} label
	 *
	 * @returns {DatasetAndField[]}
	 */
	datasetsAndFields: function(dataset, path) {
		if (_.isNil(path)) return []

		// make sure the path is a String
		path = '' + path
		if (path.indexOf('_') == -1) {
			let referencedDataset = dataset.datasetsById[path]
			return [ {
				referencedDataset,
				uniqueLabel: true,
				label: referencedDataset.get('label')
			} ]
		}
		// something like ['252_2264', '251_2312']
		let datasetIdsAndFieldIds = _.split(path, ',')
		// always return the current dataset at the beginning
		let rootDataset = dataset.datasetsById[dataset.get('rootDatasetId')]
		const datasetsAndFields = [{
			dataset,
			uniqueLink: true,
			label: rootDataset.get('label')
		}]
		// something like ['SHARP (Subject)', 'SHARP (Victim)']
		return datasetsAndFields.concat(_.map(datasetIdsAndFieldIds, datasetIdAndFieldId => {
			let [datasetId, fieldId] = _.split(datasetIdAndFieldId, '_')
			let datasetOnPath = dataset.datasetsById[datasetId]
			let field = dataset.combinedFieldsById[fieldId]
			let uniqueLink = !_.find(dataset.combinedFields, f => {
				f = unwrapModel(f)
				return f.id != field.id &&
					f.datasetId == field.datasetId &&
					f.linkedDatasetId == field.linkedDatasetId
			})
			let label = datasetOnPath.get('label')
			if (!uniqueLink) {
				label += ` (${field.label})`
			}
			return { dataset: datasetOnPath, field, uniqueLink, label }
		}))
	}

}

export default datasetPaths

datasetPaths.__filename__ = 'datasets/edit/dataset-paths.js'
